import { toast } from '@/utils/toast';

/**
 * Runs `task`; if it fails, says so in an error toast whose Retry runs it again. Resolves whether
 * it succeeded and never throws, so a failed photo upload can't undo the save that came before it.
 */
export const runWithRetry = async (
  task: () => Promise<unknown>,
  message = 'Couldn’t upload the photo.',
): Promise<boolean> => {
  try {
    await task();
    return true;
  } catch (error) {
    console.error(error);
    toast.error(message, {
      // Long enough to reach Retry on a phone; the default 4s is gone before most thumbs get there.
      duration: 10_000,
      action: { label: 'Retry', onClick: () => void runWithRetry(task, message) },
    });
    return false;
  }
};
